// 20.1.2.13 Number.parseInt(string, radix)
var $export = require('./$.export');

$export($export.S, 'Number', {parseInt: parseInt});


//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/es6.number.parse-int.js
// module id = 221
// module chunks = 0